import { BowlBlock } from '@websolutespa/payload-plugin-bowl';
import { options } from '../../options';
import { withIntegration } from './withIntegration';

export const LlmKbZendesk: BowlBlock = withIntegration(options.slug.llmKbZendesk, [
  {
    name: 'subdomain',
    type: 'withText',
    required: true,
  },
  {
    name: 'email',
    type: 'withText',
    required: true,
  },
  {
    name: 'apiToken',
    type: 'withText',
    required: true,
  },
  {
    name: 'itemType',
    type: 'select',
    required: true,
    defaultValue: 'tickets',
    options: [
      { label: 'Tickets', value: 'tickets' },
      { label: 'Articles', value: 'articles' },
      { label: 'All', value: 'all' },
    ],
  },
  {
    name: 'extension',
    type: 'text',
    hasMany: true,
  },
]);
